module.exports = __webpack_public_path__ + "879c934fbc9b4287b19675b45f76d1dd.png";